import { render, staticRenderFns } from "./PrincipalUsuario2.vue?vue&type=template&id=94a68b3e&scoped=true"
import script from "./PrincipalUsuario2.vue?vue&type=script&lang=js"
export * from "./PrincipalUsuario2.vue?vue&type=script&lang=js"
import style0 from "./PrincipalUsuario2.vue?vue&type=style&index=0&id=94a68b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a68b3e",
  null
  
)

export default component.exports